/* unplugin-vue-components disabled */import { render } from "./aboutus.vue?vue&type=template&id=1adc06b8&scoped=true"
import script from "./aboutus.vue?vue&type=script&lang=js"
export * from "./aboutus.vue?vue&type=script&lang=js"

import "./aboutus.vue?vue&type=style&index=0&id=1adc06b8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1adc06b8"]])

export default __exports__